import type React from 'react';
import Link from 'next/link';

import { cn } from '@skybeam/shared-utils/classnames/cn';

import styles from './navbar.module.css';

interface NavItemProps {
  children: React.ReactNode;
  className?: string;
  href: string;
  isActive?: boolean;
  onClick?: VoidFunction;
  rel?: string;
  target?: string;
}

export const NavItem: React.FC<NavItemProps> = ({
  children,
  className,
  href,
  isActive = false,
  onClick,
  rel,
  target,
}) => {
  return (
    <Link
      data-test={href}
      className={cn('text-base font-semibold', styles.navLink, className, {
        [styles.isActive]: isActive,
      })}
      href={href}
      onClick={onClick}
      target={target}
      rel={rel}
    >
      {children}
    </Link>
  );
};
